import React, { Component } from "react"
import './index.css';
import { m } from '../../utils';
import Icon from '../../artzu-ui/src/Icon'
import Divider from '../../artzu-ui/src/Divider'

class BookingConfirmation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showBooked: true,
      showError: false
    };
  }

  render() {
    const {
      confirmation,
      media,
      parkinglotName
    } = this.props;
    const {
      showBooked,
      showError
    } = this.state;
    return (
      <div className="book-confirm">
      {confirmation.bookings.length > 0 ? 
      <div className="booking-confirmations">
        <div className="confirm-title-panel" onClick={this.showBookings}>
          <p className="confirm-title">Confirmed Bookings ({confirmation.bookings.length})</p>
          {media === "desktop" ? null : <Icon rotation={showBooked ? 180 : null} name="DownArrow" size="xs" />}
        </div>
        {confirmation.bookings.length > 0 && (showBooked || media === "desktop") ?
          <div className="confirm-booking">
            <p>The following bookings have been made:</p>
            {confirmation.bookings.map((booking, index) => {
              return (
                <div className="confirm-panel" key={index}>
                  <div className="confirm-column-timing">
                    <div><b>{m(booking.startTime).format('dddd')},</b></div>
                    <strong>{m(booking.startTime).format('MMM Do, YYYY')}</strong>
                    <div>{m(booking.startTime).format("h A")} to {m(booking.endTime).format("h A")}</div>
                  </div>
                  <div className="confirm-column-tier">
                    <strong>{parkinglotName[0].toUpperCase() + parkinglotName.slice(1)}</strong>
                    <div>{booking.vehicleClass.toUpperCase()}</div>
                  </div>
                  <div className="confirm-column-icon">
                    <Icon name="GreenCheck" size="sm" className="check-icon" />
                  </div>
                </div>
              )
            })}
          </div> : null}
      </div> : null}
        {confirmation.bookings.length > 0 && confirmation.errors.length > 0 ? <Divider className="confirm-divide" /> : null}
        {confirmation.errors.length > 0 ?
        <div className="booking-errors">
        <div className="confirm-title-panel" onClick={this.showErrors}>
          <p className="confirm-title">Invalid Bookings ({confirmation.errors.reduce((arr, e) => {
            if (arr && !arr.find(a => e.startTime === a.startTime)) {
              arr.push(e)
            }
            return arr;
          }, []).length})</p>
          {media === "desktop" ? null : <Icon rotation={showError ? 180 : null} name="DownArrow" size="xs" />}
        </div>
        {confirmation.errors.length > 0 && (showError || media === "desktop") ?
          <div className="confirm-error">
            <p>The following selections were unable to be booked:</p>
            {confirmation.errors.reduce((arr, e) => {
              if(arr && !arr.find(a => e.startTime === a.startTime)) {
                arr.push(e)
              }
              return arr;
            }, []).map((error, index) => {
              return (
                <div className="confirm-panel" key={index}>
                  <div>
                    <strong>{m(error.startTime).format('MMM Do, YYYY')}</strong>
                    <div>{m(error.startTime).format("h A")} to {m(error.endTime).format("h A")}</div>
                  </div>
                  <p className="error-message">{error.message.replace(/^schedule\s/ig, "")}</p>
                </div>
              )
            })}
          </div> : null}
        </div> : null}
      </div>
    )
  }

  showBookings = () => {
    let show = this.state.showBooked
    this.setState({ showBooked: !show})
  }

  showErrors = () => {
    let show = this.state.showError
    this.setState({ showError: !show})
  }
}

export default BookingConfirmation;


// WEBPACK FOOTER //
// ./src/components/NewBook/BookingConfirmation.js